import {
  API_ENDPOINTS,
  get,
  handleApiError,
  handleResponse,
  post,
  Response,
} from '@/api/api.ts';
import { OS_TYPE } from '@/utils/agent.ts';
import { AxiosResponse } from 'axios';
import { ApiError } from '@/api/error/api.errors.ts';
import {
  EventEnterResponse,
  UserData,
  EventResponse,
} from '@/api/event.types.ts';
import { ConfigResponse } from '@/api/types.ts';

export const fetchConfig = async (): Promise<ConfigResponse | ApiError> => {
  try {
    const res = await get<ConfigResponse>({
      url: API_ENDPOINTS.config,
      params: { os: OS_TYPE },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const fetchEvent = async (
  eventId: string,
): Promise<Response<EventResponse>> => {
  try {
    const res = await get<Response<EventResponse>>({
      url: API_ENDPOINTS.event,
      params: { os: OS_TYPE, id: eventId },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const fetchEventEnter = async (eventId: string): Promise<UserData> => {
  try {
    const res: AxiosResponse<EventEnterResponse> = await get({
      url: API_ENDPOINTS.termsEnter,
      params: { eventId },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const submitEventEnter = async (eventId: string): Promise<void> => {
  try {
    const res = await post({
      url: API_ENDPOINTS.termsEnter,
      data: { eventId },
    });

    handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};
